import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import { routerMiddleware, routerReducer as routing, push } from 'react-router-redux'
import thunk from 'redux-thunk'

import settings from './reducers/settings'
import * as settingsActions from './actions/settings'
import sharedDataset from './reducers/shared-dataset'
import sharedDatsetActions from './actions/shared-dataset'

const syncHistoryWithStore = (store, history) => {
  const { routing } = store.getState()
  if(routing && routing.location) {
    history.replace(routing.location)
  }
}

export default function configureStore(routerHistory) {

  const router = routerMiddleware(routerHistory)

  const actionCreators = {
    ...sharedDatsetActions,
    ...settingsActions,
    push
  }

  const reducers = {
    sharedDataset,
    settings,
    routing
  }

  const middlewares = [ thunk, router ]

  const composeEnhancers = (() => {
    const compose_ = window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    if(process.env.NODE_ENV === 'development' && compose_) {
      return compose_({ actionCreators })
    }
    return compose
  })()

  const enhancer = composeEnhancers(applyMiddleware(...middlewares))
  const rootReducer = combineReducers(reducers)
  
  let store = createStore(rootReducer, {}, enhancer)
  syncHistoryWithStore(store, routerHistory)  
  return {store}
}



// WEBPACK FOOTER //
// ./src/store.js